import { IconButton, styled } from '@mui/material';

export const ProfileIconButton = styled(IconButton)`
  height: max-content;
  width: max-content;
  margin-top: 8px;
`;
